import { render } from "./ChangePageLock.vue?vue&type=template&id=2dff6bc2"
import script from "./ChangePageLock.vue?vue&type=script&lang=js"
export * from "./ChangePageLock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__